import { RuleFiftyOff } from "../modules";

export const RulesFiftyOffPage = () => {
  return <RuleFiftyOff />;
};
